import * as React from 'react';
import { SVGProps } from 'react';

const SvgService = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.3 8.4c.504 0 .9.387.9.9a.904.904 0 0 1-.9.9.891.891 0 0 1-.9-.9c0-.513.387-.9.9-.9zM3 3v8.1a5.378 5.378 0 0 0 4.626 5.319C8.184 19.128 10.578 21 13.35 21a5.853 5.853 0 0 0 5.405-3.611 5.85 5.85 0 0 0 .445-2.239v-3.321c1.044-.378 1.8-1.368 1.8-2.529a2.697 2.697 0 0 0-2.7-2.7 2.697 2.697 0 0 0-2.7 2.7c0 1.161.756 2.16 1.8 2.529v3.24c0 2.25-1.8 4.05-4.05 4.05-1.8 0-3.312-1.089-3.852-2.709C12 15.87 13.8 13.62 13.8 11.1V3h-3.6v2.7H12v5.4a3.602 3.602 0 0 1-3.6 3.6 3.602 3.602 0 0 1-3.6-3.6V5.7h1.8V3H3z" />
  </svg>
);

export default SvgService;
